import React, { useState, useEffect } from 'react'

export default function CryptoRecipientsPage({ onClose, darkMode, isAdmin }) {
  const [recipients, setRecipients] = useState([])
  const [loading, setLoading] = useState(true)
  const [editItem, setEditItem] = useState(null) // null | {} | {id,...}
  const [saving, setSaving] = useState(false)
  const [deleteConfirm, setDeleteConfirm] = useState(null)

  const bg = darkMode ? '#0f1117' : '#f7f7f5'
  const cardBg = darkMode ? '#1a1f2e' : 'white'
  const textColor = darkMode ? '#e2e8f0' : '#1a1a1a'
  const subColor = darkMode ? '#94a3b8' : '#888'
  const borderColor = darkMode ? '#2d3748' : '#e0e0dc'
  const inputStyle = { width: '100%', padding: '9px 12px', borderRadius: 8, border: `1px solid ${borderColor}`, background: darkMode ? '#252b3b' : 'white', color: textColor, fontSize: 14, boxSizing: 'border-box' }

  function authHeaders(extra) {
    const token = localStorage.getItem('auth_token')
    return { Authorization: `Bearer ${token}`, ...extra }
  }

  async function load() {
    setLoading(true)
    try {
      const r = await fetch('/api/crypto-recipients', { headers: authHeaders() })
      setRecipients(await r.json())
    } catch(e) { console.error(e) }
    setLoading(false)
  }

  useEffect(() => { load() }, [])

  async function save() {
    setSaving(true)
    try {
      const h = authHeaders({ 'Content-Type': 'application/json' })
      if (editItem.id) {
        await fetch(`/api/crypto-recipients/${editItem.id}`, { method: 'PUT', headers: h, body: JSON.stringify(editItem) })
      } else {
        await fetch('/api/crypto-recipients', { method: 'POST', headers: h, body: JSON.stringify(editItem) })
      }
      setEditItem(null)
      await load()
    } catch(e) { alert('Ошибка: ' + e.message) }
    setSaving(false)
  }

  async function remove(id) {
    await fetch(`/api/crypto-recipients/${id}`, { method: 'DELETE', headers: authHeaders() })
    setDeleteConfirm(null)
    await load()
  }

  return (
    <div style={{ background: bg, minHeight: '100vh', color: textColor }}>
      <div style={{ maxWidth: 700, margin: '0 auto', padding: '16px 16px 40px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
          <button onClick={onClose} style={{ background: 'none', border: `1px solid ${borderColor}`, borderRadius: 8, padding: '6px 14px', cursor: 'pointer', color: textColor, fontSize: 14 }}>← Назад</button>
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>💎 Крипто-получатели</h2>
          {isAdmin && (
            <button onClick={() => setEditItem({ name: '', address: '', description: '', country: '' })}
              style={{ marginLeft: 'auto', background: '#1a1a1a', color: 'white', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
              + Добавить
            </button>
          )}
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', color: subColor, padding: 40 }}>Загрузка...</div>
        ) : recipients.length === 0 ? (
          <div style={{ textAlign: 'center', color: subColor, padding: 40 }}>Получателей нет</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {recipients.map(r => (
              <div key={r.id} style={{ background: cardBg, borderRadius: 12, padding: '14px 16px', border: `1px solid ${borderColor}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 4 }}>{r.name}</div>
                    {r.country && <div style={{ fontSize: 12, color: subColor, marginBottom: 2 }}>🌍 {r.country}</div>}
                    {r.description && <div style={{ fontSize: 12, color: subColor, marginBottom: 4 }}>{r.description}</div>}
                    <div style={{ fontFamily: 'monospace', fontSize: 12, color: darkMode ? '#63b3ed' : '#185FA5', wordBreak: 'break-all', background: darkMode ? '#252b3b' : '#f0f4fa', borderRadius: 6, padding: '4px 8px', marginTop: 4 }}>
                      {r.address}
                    </div>
                    <div style={{ fontSize: 11, color: subColor, marginTop: 4 }}>TRC-20 · USDT</div>
                  </div>
                  {isAdmin && (
                    <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                      <button onClick={() => setEditItem({ ...r })}
                        style={{ fontSize: 12, padding: '5px 10px', borderRadius: 7, border: `1px solid ${borderColor}`, background: 'none', color: textColor, cursor: 'pointer' }}>✏️</button>
                      {deleteConfirm === r.id ? (
                        <>
                          <button onClick={() => remove(r.id)} style={{ fontSize: 12, padding: '5px 10px', borderRadius: 7, border: 'none', background: '#E24B4A', color: 'white', cursor: 'pointer', fontWeight: 600 }}>Удалить</button>
                          <button onClick={() => setDeleteConfirm(null)} style={{ fontSize: 12, padding: '5px 8px', borderRadius: 7, border: `1px solid ${borderColor}`, background: 'none', color: subColor, cursor: 'pointer' }}>Нет</button>
                        </>
                      ) : (
                        <button onClick={() => setDeleteConfirm(r.id)}
                          style={{ fontSize: 12, padding: '5px 10px', borderRadius: 7, border: `1px solid ${borderColor}`, background: 'none', color: '#E24B4A', cursor: 'pointer' }}>✕</button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {editItem && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={e => e.target === e.currentTarget && setEditItem(null)}>
          <div style={{ background: cardBg, borderRadius: 16, padding: 24, width: 460, maxWidth: '95vw', boxShadow: '0 8px 40px rgba(0,0,0,0.18)' }}>
            <h3 style={{ margin: '0 0 20px', fontSize: 16, fontWeight: 700, color: textColor }}>{editItem.id ? 'Редактировать' : 'Новый получатель'}</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div>
                <div style={{ fontSize: 12, color: subColor, marginBottom: 4 }}>Имя *</div>
                <input style={inputStyle} value={editItem.name} onChange={e => setEditItem(p => ({ ...p, name: e.target.value }))} placeholder="Имя агента или компании" />
              </div>
              <div>
                <div style={{ fontSize: 12, color: subColor, marginBottom: 4 }}>TRC-20 адрес *</div>
                <input style={inputStyle} value={editItem.address} onChange={e => setEditItem(p => ({ ...p, address: e.target.value }))} placeholder="T..." />
              </div>
              <div>
                <div style={{ fontSize: 12, color: subColor, marginBottom: 4 }}>Страна</div>
                <input style={inputStyle} value={editItem.country || ''} onChange={e => setEditItem(p => ({ ...p, country: e.target.value }))} placeholder="Нигерия, Замбия..." />
              </div>
              <div>
                <div style={{ fontSize: 12, color: subColor, marginBottom: 4 }}>Описание</div>
                <input style={inputStyle} value={editItem.description || ''} onChange={e => setEditItem(p => ({ ...p, description: e.target.value }))} placeholder="Агент по визам, расходы в дорогу..." />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
              <button onClick={save} disabled={saving || !editItem.name.trim() || !editItem.address.trim()}
                style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: 'none', background: '#1a1a1a', color: 'white', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
                {saving ? 'Сохранение...' : 'Сохранить'}
              </button>
              <button onClick={() => setEditItem(null)}
                style={{ padding: '10px 16px', borderRadius: 8, border: `1px solid ${borderColor}`, background: 'none', color: subColor, fontSize: 14, cursor: 'pointer' }}>
                Отмена
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
